export const GET_FAQ_ERROR_MESSAGE = 'Erro ao buscar os dados de FAQ.'

export const FAQ_VOTE_SUCCESS = 'Avaliação enviada com sucesso!'

export const FAQ_VOTE_ERROR = 'Erro ao enviar a avaliação.'

export const SEARCH_FAQ_ERROR_MESSAGE = 'Erro ao buscar respostas a sua pergunta.'
